import { render, staticRenderFns } from "./YikudiaobodanForm.vue?vue&type=template&id=ed10c30e&scoped=true&"
import script from "./YikudiaobodanForm.vue?vue&type=script&lang=js&"
export * from "./YikudiaobodanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed10c30e",
  null
  
)

export default component.exports